// extracted by mini-css-extract-plugin
export default {"image":"sX-z","loaded":"tX-z"};